__turbopack_context__.v({
  "rose": "Tape-module__SyFx4q__rose",
  "tape": "Tape-module__SyFx4q__tape",
  "teal": "Tape-module__SyFx4q__teal",
});
